import { render, staticRenderFns } from "./addCoach.vue?vue&type=template&id=0a0476fb&"
import script from "./addCoach.vue?vue&type=script&lang=js&"
export * from "./addCoach.vue?vue&type=script&lang=js&"
import style0 from "./addCoach.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports